export default "__VITE_ASSET__CS270MMY__"